import { useTranslation } from 'react-i18next';
import { debounce } from 'lodash-es';

import { fetchPptFile } from '@/api/v4/export.api';
import { notify } from '@/ui/snackbar/notify';

import { useProject } from '../overview/use-project.query';
import { projectIdState } from '../project.state';
import { useAtomValue } from 'jotai';

export const useExportHandlers = () => {
  const { t } = useTranslation('projects', {
    keyPrefix: 'projectOverview',
  });
  const projectId = useAtomValue(projectIdState);
  const { data: project } = useProject(projectId);

  const handleExportToPpt = async () => {
    if (!project) return;

    try {
      const response: any = await fetchPptFile(project.id);

      const data = Uint8Array.from(response.data);
      const content = new Blob([data.buffer], {
        type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      });

      const encodedUri = window.URL.createObjectURL(content);
      const link = document.createElement('a');

      link.setAttribute('href', encodedUri);
      link.setAttribute('download', `${project.name}.pptx`);

      link.click();

      debounce(() => link.remove(), 300);
    } catch {
      notify({ message: t`exportErrors.ppt` });
    }
  };

  return {
    handleExportToPpt,
  };
};
